import { render } from "./EnterCodeScreen.vue?vue&type=template&id=bd20418c"
import script from "./EnterCodeScreen.vue?vue&type=script&lang=js"
export * from "./EnterCodeScreen.vue?vue&type=script&lang=js"

import exportComponent from "/Users/peterdevos/Sites/multiple_choice_aethon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__